<template>
    <div>
    <el-drawer
        title="子商品"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
        append-to-body
    >
        <div class="drawer-content">
            <div v-if="dataList && dataList.length > 1" class="color-info">可拖动排序</div>
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="mini"
                stripe
                row-key="id"
                class="sortable-table MT10"
            >
                <el-table-column prop="id" label="商品ID"></el-table-column>
                <el-table-column prop="name" label="商品名称" min-width="250"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="add">新增商品</el-button>
        </div>
    </el-drawer>
    <sub-goods-edit ref="subGoodsEdit" :subscribeId="id" @onUpdate="getDataList"></sub-goods-edit>
</div>
</template>
<script>
import SubGoodsEdit from './SubGoodsEdit.vue';
import Sortable from "sortablejs";
export default {
    components: {SubGoodsEdit},
    data(){
        return{
            drawerShow: false,
            listLoading: false,
            dataList: [],
            id: ""
        }
    },
    methods:{
        show(id){
            this.id = id;
            this.getDataList();
            this.drawerShow = true;
        },
        close(){
            this.drawerShow = false;
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/subscribe/sub/list",
                method: "POST",
                params: {
                    id: this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.dataList = result || [];
                    this.drag();
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        edit(id){
            this.$refs.subGoodsEdit.show(id);
        },
        del(id){
            this.$confirm("是否确认删除该子商品", '删除', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.listLoading = true;
		        this.$request({
		            url: '/subscribe/sub/delete',
		            method: 'POST',
		            params: {id:id}
		        }).then(res => {
		            const { state, msg } = res.data;
		            if( state == 1 ){
		                this.getDataList();
		            }else{
		                this.$message.error(msg || '请求失败');
		            }
		        }).catch(() => {
		            this.$message.error('请求错误');
		        }).finally(() => {
		            this.listLoading = false;
		        });
		    })
        },
        add(){
            this.$refs.subGoodsEdit.show();
        },
        //拖拽排序
        drag(){
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                Sortable.create(el, {
                    disabled: false, // 拖拽不可用? false 启用
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    onEnd: (e) => { // 拖拽结束时的触发
                        let arr = [...this.dataList]; // 获取表数据
                        arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                        
                        this.$nextTick(function () {
                            const a1 = (this.dataList.map(a => a.id)).toString();
                            const a2 = (arr.map(a => a.id)).toString();
                            if(a1 != a2){
                                this.dataList = arr;
                                this.updateSort();
                            }
                        })
                    },
                });
            })
        },
        //排序
        updateSort(){
            this.dataList.map( (item,index) => {
                item.sort = index;
            })

            this.$request({
                url: '/subscribe/sub/sort',
                method: "post",
                data: this.dataList,
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("排序成功");
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    
                });
        },
    }
}
</script>

<style lang="scss" scoped>
    
</style>